import { useTranslation } from 'react-i18next';

const HowItWorksSection = () => {
  const { t } = useTranslation();

  const steps = [
    { num: '01', titleKey: 'howItWorks.step1.title', descKey: 'howItWorks.step1.description', icon: 'fa-wallet' },
    { num: '02', titleKey: 'howItWorks.step2.title', descKey: 'howItWorks.step2.description', icon: 'fa-layer-group' },
    { num: '03', titleKey: 'howItWorks.step3.title', descKey: 'howItWorks.step3.description', icon: 'fa-file-signature' },
    { num: '04', titleKey: 'howItWorks.step4.title', descKey: 'howItWorks.step4.description', icon: 'fa-coins' },
  ];

  return (
    <section id="how-it-works" className="section-x how-it-works">
      <div className="container">
        <div className="row">
          <div className="col-lg-9 mx-auto text-center mb-5">
            <div className="eyebrow eyebrow--center mb-3" data-aos="fade-up">
              <span>{t('howItWorks.eyebrow')}</span>
            </div>
            <h2 className="section-heading" data-aos="fade-up">
              {t('howItWorks.titleLead')}{' '}
              <span className="gold-text">{t('howItWorks.titleHighlight')}</span>
            </h2>
            <p className="section-subheading" data-aos="fade-up" data-aos-delay="80">
              {t('howItWorks.subtitle')}
            </p>
          </div>
        </div>

        <div className="hiw-grid">
          {steps.map((step, i) => (
            <div key={step.num} className="hiw-step" data-aos="fade-up" data-aos-delay={i * 80}>
              <div className="hiw-step__num mono">{step.num}</div>
              <div className="hiw-step__icon">
                <i className={`fas ${step.icon}`} />
              </div>
              <h4 className="hiw-step__title">{t(step.titleKey)}</h4>
              <p className="hiw-step__desc">{t(step.descKey)}</p>
              {i < steps.length - 1 && (
                <div className="hiw-step__connector" aria-hidden="true">
                  <i className="fas fa-chevron-right" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
